export function extractUrl(text: string): string | null {
  const startMarker = 'https://';
  const startIndex = text.indexOf(startMarker);

  if (startIndex === -1) return null;

  const endIndex = text.indexOf(' ', startIndex);
  if (endIndex === -1) {
    return text.substring(startIndex);
  }

  return text.substring(startIndex, endIndex);
}

export function splitAndRemoveUrl(text: string): string[] {
  // Split into sentences based on periods followed by space or end of string
  const sentences = text.split(/(?<=\.)\s+/);

  // Find and remove the URL from each sentence
  return sentences.map((sentence) => {
    const urlStart = sentence.indexOf('https://');
    if (urlStart !== -1) {
      const urlEnd = sentence.indexOf(' ', urlStart) !== -1 ? sentence.indexOf(' ', urlStart) : sentence.length;
      return sentence.substring(0, urlStart) + sentence.substring(urlEnd).trim();
    }
    return sentence;
  });
}
